<pui-table2 [dataSource]="groupUsers" [trackBy]="trackBy" [sortBy]="sort().key" [sortDirection]="sort().direction"
  (sortChange)="onSortChange($event)" class="details-table">
  <ng-template #header>
    <th pui-column-header key="username">Użytkownik</th>
    <th>Imię</th>
    <th>Nazwisko</th>
    <th>Organizacja</th>
    <th>Jednostka</th>
    <th>Rola</th>
    <th>Akcje</th>
  </ng-template>
  <ng-template #row let-row>
    <tr>
      <td>{{ row.username }}</td>
      <td>{{ row.firstName }}</td>
      <td>{{ row.lastName}}</td>
      <td>{{ row.organization }}</td>
      <td>{{ row.responsibleUnit }}</td>
      <td>{{ row.role }}</td>
      <td>
        <button pui-button variant="tertiary" (click)="onEditUser(row.username)"><pui-icon class="action-icon" left
            icon="edit-03" /></button>
        <button pui-button variant="tertiary" (click)="onDeleteUser(row)"><pui-icon left icon="trash-03"
            class="remove-icon" /></button>
      </td>
    </tr>

  </ng-template>
</pui-table2>